import type { EventOperatorRole } from './operatorRoles'

export type OperatorModuleId='event-builder'|'catalog-builder'|'orders'|'cash-register'|'production'|'dashboard'|'payments'|'delivery'

export const EVENT_OPERATOR_MODULES:Record<EventOperatorRole,readonly OperatorModuleId[]>={
 admin:['event-builder','catalog-builder','orders','cash-register','production','dashboard','payments','delivery'],
 supervisor:['orders','cash-register','production','dashboard','payments','delivery'],
 cashier:['orders','cash-register','payments'],
 mobile_operator:['orders','payments'],
 production:['production'],
 delivery:['delivery','orders'],
}

export function canOperatorAccessModule(role:EventOperatorRole,moduleId:string){return EVENT_OPERATOR_MODULES[role].includes(moduleId as OperatorModuleId)}
